import { useContext, useEffect, useState } from "react";
import { BiEdit } from "react-icons/bi";
import { FaGreaterThan } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AlertContext from "../../../context/Alert/AlertContext";
import DataTable2 from "../../../context/components/DataTable2";
import axiosPrivate from "../../../hooks/axiosPrivate";
import LoaderContext from "../../../context/loader/LoaderContext";
import styles from "../Dealer/dealer.module.css";
import { showSuccessToast, showErrorToast } from "../../../Toster";

const Product = (props) => {
  const { setIsLoading } = useContext(LoaderContext);
  const { alertMessage, setAlertMessage } = useContext(AlertContext);
  const [productState, setProductState] = useState([]);
  const [isSync, setIsSync] = useState(false);
  const headers = [
    { name: "TALLY NAME", field: "tally_name", sortable: true, classKey: "" },
    {
      name: "GST",
      field: "gst_applicable",
      sortable: true,
      classKey: "w80",
    },
    { name: "Unit", field: "unit", sortable: true, classKey: "" },
    { name: "Weight", field: "weight", sortable: true, classKey: "" },
    {
      name: "Product in carton / box",
      field: "product_in_box",
      sortable: true,
      classKey: "w-cartoon",
    },
    { name: "Rate", field: "rate", sortable: true, classKey: "" },
    { name: "GST(%)", field: "igst_rate", sortable: true, classKey: "" },

    { name: "ACTION", field: "action", classKey: "" },
  ];

  const searchItems = ["tally_name", "unit", "weight", "rate", "igst_rate", "gst_applicable",  "product_in_box" ];

  const syncProductFromTally = async () => {
    setIsLoading(true); // Show loader
    setIsSync(true); // Show loader
    await axiosPrivate.post("stocks/fetch").then((response) =>{
      showSuccessToast("Products synced successfully")
    productsList()
    }).catch((error) => {
      if (Array.isArray(error.response.data.errors)) {
        showErrorToast(error.response.data.errors[0]?.msg);
      } else {
        showErrorToast(error.response.data.errors?.msg);
      }
    }).finally(() =>{
      setIsLoading(false); // Hide loader
      setIsSync(false);
    });
  };

  const productsList = () => {
    setIsLoading(true);
    const options = {
      headers: { "content-type": "application/json" },
    };
    axiosPrivate.get("stocks", options).then((stocks) => {
      const stocksData = stocks?.data?.data?.map((value, key) => {
        let buttons = [];
        if (true)
          buttons.push(
            <Link
              key="editButton##1"
              type="button"
              to={`/admin/product/edit/${value.id}`}
              className="btn btn-icon"
              title="Edit"
            >
              <BiEdit style={{ color: "green" }} size={18} />
            </Link>
          );
          value["action"] = buttons.length > 0 ? buttons : "-";
          return value;
        });

        setProductState(stocksData);
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          //response status is an error code
          showErrorToast("Internal server error");
        }
        setIsLoading(false);
      });
  };

  useEffect(() => {
    productsList();
  }, []);

  

  // alert meaasge
  useEffect(() => {
    if (alertMessage != null) {
      toast(alertMessage.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setAlertMessage(null);
    }
  }, [alertMessage]);

  return (
    <>
      <div className="section-body">
        <div className="container-fluid d-flex justify-content-between">
          {/* hearder breadcrumb */}
          <div className="card-header">
            <strong className="top-left-heading">Products</strong>

            <ol className="headerroutes breadcrumb m-0 bg-none ">
              <li className="item color-gray">|</li>
              <li className="item">
                <Link to="/admin/dashboard" className="route-heading item mx-2">
                  Dashboard
                </Link>
              </li>
              <li className="item">
                <FaGreaterThan className="grater-than-route" />
              </li>
              <li className="route-heading item mx-2 mt-1">Products </li>
            </ol>
          </div>{isSync && (
        <div
          className={styles.overlayMessage}
        >
          Products syncing from Tally...
        </div>
      )}
          <button
            type="button"
            className={`btn btn-primary add_btn ${styles?.syncTallyButton}`}
            data-toggle="modal"
            data-target="#exampleModal"
            onClick={syncProductFromTally}
          >
            Sync Tally
          </button>

        </div>
        <div className="section-body">
          <div className="container-fluid">
            <div className="tab-content ">
              <div
                className="tab-pane fade show active"
                id="user-list"
                role="tabpanel"
              >
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      {
                        <DataTable2
                          lists={productState}
                          headers={headers}
                          searchItems={searchItems}
                        />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
